/**
 * Plausibilitätsprüfung einer Zeitbuchung vor dem Absenden.
 *
 * Anlass (T26-03524, 29.10.2026): gemeint war 10:00–10:30, gebucht wurden 00:00–10:30 = 10,5 h.
 * Das Formular rechnet Start = Ende − Dauer; ein Zwischenstand der Startzeit (Stunde 00) oder
 * „10:30" im Dauer-Feld (gelesen als 10 h 30 min) ergibt genau dieses Bild. Statt jede
 * Eingabe-Variante einzeln abzufangen: ungewöhnliche Buchungen vor dem Absenden ausschreiben
 * und bestätigen lassen.
 */

/** Ab dieser Dauer (Stunden) wird nachgefragt — ein Einsatz über 8 h am Stück ist selten. */
export const LONG_BOOKING_HOURS = 8;
/** Start vor dieser Stunde (Ortszeit) wird nachgefragt — Notdienst ja, aber selten. */
export const EARLY_START_HOUR = 6;

const hhmm = (d: Date) =>
  `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;

const formatDuration = (hours: number) => {
  const total = Math.round(hours * 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return h === 0 ? `${m} Min.` : m === 0 ? `${h} Std.` : `${h} Std. ${m} Min.`;
};

/**
 * `null` = unauffällig. Sonst der Text für die Rückfrage, mit Zeitraum und Dauer ausgeschrieben,
 * damit der Fehler beim Lesen auffällt.
 */
export function bookingPlausibilityWarning(start: Date, end: Date, hours: number, forName?: string): string | null {
  const reasons: string[] = [];
  if (hours > LONG_BOOKING_HOURS) reasons.push(`mehr als ${LONG_BOOKING_HOURS} Stunden`);
  if (start.getHours() < EARLY_START_HOUR) reasons.push(`Beginn vor ${EARLY_START_HOUR}:00 Uhr`);
  if (reasons.length === 0) return null;
  const who = forName ? ` für ${forName}` : '';
  return (
    `Bitte prüfen (${reasons.join(', ')}):\n\n` +
    `Gebucht wird${who}: ${start.toLocaleDateString('de-DE')} ${hhmm(start)}–${hhmm(end)} Uhr = ${formatDuration(hours)}.\n\n` +
    `Stimmt das so?`
  );
}
